// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2aVRn","header":"ClearentDisclaimer_header__3covr","inner":"ClearentDisclaimer_inner__3AUaC"};